"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var LegendsTooltip = function (props) {
    var children = props.children, title = props.title;
    var _a = (0, react_1.useState)(false), open = _a[0], setOpen = _a[1];
    var timeout;
    var showTip = function () {
        timeout = setTimeout(function () { return setOpen(true); }, 100);
    };
    var hideTip = function () {
        clearTimeout(timeout);
        setOpen(false);
    };
    return (react_1.default.createElement(TooltipWrapper, { onMouseEnter: showTip, onMouseLeave: hideTip },
        children,
        react_1.default.createElement(Tip, { "$open": open }, title)));
};
var TooltipWrapper = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  position: relative;\n  justify-content: center;\n"], ["\n  display: flex;\n  position: relative;\n  justify-content: center;\n"])));
var Tip = styled_components_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  position: absolute;\n  top: calc(100% + 10px);\n  font-size: 10px;\n  background-color: #4d4d4de3;\n  color: #ffffff;\n  border-radius: 5px;\n  z-index: 10;\n  pointer-events: none;\n  transition: opacity 0.1s, transform 0.15s;\n  opacity: 0;\n  padding: 0 7px;\n  transform-origin: top;\n  transform: scaleY(0);\n\n  ", "\n"], ["\n  position: absolute;\n  top: calc(100% + 10px);\n  font-size: 10px;\n  background-color: #4d4d4de3;\n  color: #ffffff;\n  border-radius: 5px;\n  z-index: 10;\n  pointer-events: none;\n  transition: opacity 0.1s, transform 0.15s;\n  opacity: 0;\n  padding: 0 7px;\n  transform-origin: top;\n  transform: scaleY(0);\n\n  ", "\n"])), function (p) {
    return p.$open &&
        "\n    opacity: 1;\n    transform: scaleY(1);\n  ";
});
exports.default = LegendsTooltip;
var templateObject_1, templateObject_2;
